// إعداد القائمة الجانبية لبوابة المدرب المستقلة — مستقل عن قائمة المنشأة
export const coachNavigation = [
  {
    group: 'لوحتي',
    key: 'main',
    items: [
      { name: 'الرئيسية', href: '/coach', icon: 'home' },
      { name: 'ملفي المهني', href: '/coach/profile', icon: 'users' },
      { name: 'الطلبات والعروض', href: '/coach/requests', icon: 'inbox' },
      { name: 'المنشآت المرتبط بها', href: '/coach/organizations', icon: 'building' },
      { name: 'طاقم العمل', href: '/coach/crew', icon: 'userGroup' },
    ],
  },
  {
    group: 'العمل الفني',
    key: 'studio',
    items: [
      { name: 'لوحة العمل الفني', href: '/coach/studio', icon: 'dumbbell' },
      { name: 'مكتبة التمارين', href: '/coach/studio/exercises', icon: 'field' },
      { name: 'إنشاء تمرين', href: '/coach/studio/exercises/new', icon: 'plus' },
      { name: 'الخطط التدريبية', href: '/coach/studio/plans', icon: 'clipboard' },
      { name: 'جدول التدريبات', href: '/coach/studio/schedule', icon: 'calendar' },
      { name: 'التقارير الفنية', href: '/coach/studio/reports', icon: 'chart' },
    ],
  },
];

export const COACH_ROUTE_TITLES = {
  '/coach': 'الرئيسية',
  '/coach/profile': 'ملفي المهني',
  '/coach/requests': 'الطلبات والعروض',
  '/coach/organizations': 'المنشآت المرتبط بها',
  '/coach/crew': 'طاقم العمل',
  '/coach/studio': 'لوحة العمل الفني',
  '/coach/studio/exercises': 'مكتبة التمارين',
  '/coach/studio/exercises/new': 'إنشاء تمرين',
  '/coach/studio/plans': 'الخطط التدريبية',
  '/coach/studio/schedule': 'جدول التدريبات',
  '/coach/studio/reports': 'التقارير الفنية',
};

export const getCoachRouteTitle = (pathname) => COACH_ROUTE_TITLES[pathname] || 'لوحة المدرب';
